<template width="200px">
  <div>
    <v-menu 
      v-model="menu" 
      :close-on-content-click="true" 
      offset-y 
      
    >
      <template v-slot:activator="{ on: tooltip }" min-width="400">
          <v-row>
            <v-btn block x-small class="red darken-4" v-on="tooltip" @click="logout">
              <v-icon x-small>mdi-logout</v-icon>
              {{ $t("Menu.rightMenu.Logout") }}
            </v-btn>
          </v-row>
          <v-row>
            <span class="caption">{{ countDown }} {{ $t("Session.Min2End") }}</span>
          </v-row>
      </template>
    </v-menu>
  </div>
</template>

<script>
import i18n from "../i18n";

export default {
  name: "Language",
  data() {
    return {
      locale: i18n.locale,
      menu: "",
      logoutTimer: null,
      countDown : 60,
      

    };
  },
  beforeCreate() {

  },
  beforeMount() {
    var remainedTime = new Date(this.$cookies.get("TPSessionTime")) - new Date();
    this.countDown = Math.round(remainedTime / 60 / 1000);
  },
  mounted() {
    this.countDownTimer();
  },
  methods: {
    countDownTimer() {
      setTimeout(() => {
        if (this.$cookies.isKey("TPSessionTime") == false) {
          this.logout();
        }
        var remainedTime = (new Date(this.$cookies.get("TPSessionTime")) - new Date());
        this.countDown = Math.round(remainedTime / 60 / 1000);

        this.countDownTimer();
      }, 1000)
      
    },
    logout() {
      window.Store.dispatch("logout");
      location.reload();
    }
  }
}

</script>

<style lang="scss">
.selected-lang {
  text-transform: uppercase;
  cursor: pointer;
  width: 100%;
  text-align: right;
  margin-left: 3px;
}
</style>    